/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import PolaBanglesHeader from "views/MyCompo/PolaBanglesHeader";
import PolaBanglesHeaderLinks from "views/MyCompo/PolaBanglesHeaderLinks";
import PolaBanglesFooter from "views/MyCompo/PolaBanglesFooter";
// import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import TermsDescription from "views/MyCompo/TermsDescription";
// import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
// import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function TermCondition() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://polabangles.com/terms-and-conditions";
  const seoTitle = "Terms and Conditions | POLA BANGLES";
  const seoDescription =
    "Read the Terms and Conditions of POLA BANGLES before using our website, placing orders, or purchasing imitation jewellery products and services.";
  const seoKeywords =
    "POLA BANGLES terms and conditions, jewellery website terms, bangles terms and conditions, imitation jewellery terms, website usage policy";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const termsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Terms and Conditions",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "POLA BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="POLA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(termsSchema)}
        </script>
      </Helmet>
      <PolaBanglesHeader
        brand="Home"
        links={<PolaBanglesHeaderLinks dropdownHoverColor="danger" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "danger",
        }}
      />
      <Parallax
        image={require("assets/img/Terms-And-Condition.jpg").default}
        // style={{backgrounColor: "#3c4858"}}
        filter="dark"
        small
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1
                style={{
                  color: "#fff",
                  fontFamily: "Tahoma",
                  fontWeight: "bold",
                }}
              >
                Terms And Condition
              </h1>
              <h4 style={{ color: "#fff" }}></h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <TermsDescription />
          {/* <SectionTeam /> */}
          {/* <SectionOffice /> */}
          <br />
        </div>
      </div>
      <PolaBanglesFooter />
    </div>
  );
}
